let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
 

// des popup enable js

// $('.button-des-pop').unbind('click').bind('click', function() {
//   $(this).closest('.juo-card').find('.product-popup').css('display', 'flex');
// });

 
// $('.popup-product-close').unbind('click').bind('click', function() {
//   $(this).closest('.product-popup').css('display', 'none');
// });

 
// $('.product-pop-overlay').unbind('click').bind('click', function() {
//   $(this).closest('.product-popup').css('display', 'none');
// });
